<template>
  <el-container  type="flex" class="main_container">
    <base-header>
      用户总数：{{this.content.client_total_count}}
    </base-header>
    <el-main>
      <div  class="chart_box">
        <base-chart
          chartUrl="client_daily"
          chartText="用户日增长"
          want="client_count"
          :total="total_day"
        ></base-chart>
        <base-chart
          chartUrl="client_monthly"
          chartText="用户月增长"
          want="client_count"
          :total="total_month"
        ></base-chart>
        <base-chart
          chartUrl="client_incr_rate_daily"
          chartText="用户日增长率"
          want="client_incr_rate"
          type="percent"
          :total="total_day"
        ></base-chart>
        <base-chart
          chartUrl="client_incr_rate_monthly"
          chartText="用户月增长率"
          type="percent"
          want="client_incr_rate"
          :total="total_month"
        ></base-chart>
        <base-chart
          chartUrl="client_dau"
          chartText="用户日活"
          want="client_dau"
          :total="total_day"
        ></base-chart>
        <base-chart
          chartUrl="client_mau"
          chartText="用户月活"
          want="client_mau"
          :total="total_month"
        ></base-chart>
        <base-chart
          chartUrl="retention_rate_yesterday_daily"
          chartText="昨日留存率"
          want="retention_rate_yesterday"
          type="percent"
          :total="total_day"
        ></base-chart>
        <base-chart
          chartUrl="retention_rate_7_day_daily"
          chartText="7日留存率"
          want="retention_rate_7_day"
          type="percent"
          :total="total_day"
        ></base-chart>
        <base-chart
          chartUrl="retention_rate_30_day_daily"
          chartText="30日留存率"
          want="retention_rate_30_day"
          type="percent"
          :total="total_day"
        >
        </base-chart>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import chartMixin from '../../../../mixins/chart'

export default {
  name: 'DBClient',
  mixins: [chartMixin]
}
</script>
